document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    var ctx = document.getElementById("myChart").getContext("2d");

    var gradient = ctx.createLinearGradient(0, 0, 300, 0);
    gradient.addColorStop(0, "rgb(29, 135, 68)");
    gradient.addColorStop(1, "rgb(238, 234, 55)");

    const progressTotal = document.querySelector(".js-progress-total");

    let progress = 100 - parseInt(progressTotal.dataset.value);

    var data = {
      datasets: [
        {
          data: [100, progress],
          backgroundColor: [gradient, "#E0E0E0"],
          hoverOffset: 4,
        },
      ],
    };

    var config = {
      type: "doughnut",
      data: data,
      options: {
        cutout: "80%",
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    };

    var myChart = new Chart(ctx, config);
  }, 1000);
});
